import type { HasIPenSharedMails } from '@ipen-portal/plugin-common';
import type { FC } from 'react';

import { Icon } from '@iconify/react';
import { CopyButton } from '@ipen-portal/plugin-common-react';
import { colors } from '@ipen/components';
import {
  Divider,
  Link,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { Fragment } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  divider: {
    backgroundColor: theme.palette.divider,
    height: 2,
    marginLeft: 54,
  },
  link: {
    ...theme.typography.link,
  },
  muiBeforeIcon: {
    height: 40,
    marginLeft: -18,
    marginRight: 12,
    width: 40,
  },
  secondary: {
    color: colors.eonNeutral.color700,
    textTransform: 'capitalize',
  },
}));

type SharedMailProps = {
  sharedMail: HasIPenSharedMails | undefined;
};

export const SharedMailComponent: FC<SharedMailProps> = ({ sharedMail }) => {
  const sharedMails = sharedMail?.spec.sharedMails ?? [];
  const { classes } = useStyles();

  return (
    <>
      {sharedMails.map(mail => (
        <Fragment key={mail.email}>
          <ListItem aria-label={mail.title}>
            <Icon
              className={classes.muiBeforeIcon}
              icon="material-symbols:mail-outline"
            />
            <ListItemText
              primary={(
                <Typography variant="body1">
                  <Link
                    className={classes.link}
                    href={`mailto:${mail.email}`}
                    title={mail.email}
                  >
                    {mail.email}
                  </Link>
                </Typography>
              )}
              secondary={(
                <Typography aria-label="Contact" variant="body1">
                  <span className={classes.secondary}>{mail.title}</span>
                </Typography>
              )}
            />
            <CopyButton copyString={mail.email} title="E-Mail" />
          </ListItem>
          <Divider className={classes.divider} />
        </Fragment>
      ))}
    </>
  );
};
